import {Injectable} from '@angular/core';
import {ActivePolizzebuchungStore} from '@app/core/state/active-polizzebuchung/active-polizzebuchung.store';
import {select} from "@ngneat/elf";
import {toBoolean} from "@app/core/util/check.util";

@Injectable({ providedIn: 'root' })
export class ActivePolizzebuchungQuery {

  isLoading$ = this.store.data.pipe(select(sessionStore => toBoolean(sessionStore.loading)));
  isErrorLoading$ = this.store.data.pipe(select(sessionStore => toBoolean(sessionStore.errorLoading)));
  currentPolizzebuchung$ = this.store.data.pipe(select(sessionStore => sessionStore.polizzebuchung));
  otherPolizzebuchungen$ = this.store.data.pipe(select(sessionStore => sessionStore.otherBuchungen));
  otherPolizzebuchungenLoading$ = this.store.data.pipe(select(sessionStore => sessionStore.otherBuchungenLoading));

  constructor(protected store: ActivePolizzebuchungStore) {
  }

}
